import React from 'react';
import { Database, ChevronDown } from 'lucide-react';
import type { DataSources } from '@/services/PagesServices/CustomReportBuilderService';
import { DATA_SOURCE_ICONS, DEFAULT_DATA_SOURCE_ICON } from '../constants';
import { useReportBuilderState } from '../hooks/useReportBuilderState';

interface DataSourceSectionProps {
  dataSources: DataSources | undefined;
  isLoading: boolean;
}

const DataSourceSection: React.FC<DataSourceSectionProps> = ({ dataSources, isLoading }) => {
  const expanded = useReportBuilderState(s => s.expandedSections.dataSource);
  const selectedDataSource = useReportBuilderState(s => s.selectedDataSource);
  const toggleSection = useReportBuilderState(s => s.toggleSection);
  const setSelectedDataSource = useReportBuilderState(s => s.setSelectedDataSource);

  return (
    <div className="crb-config-section">
      <div className="crb-config-header" onClick={() => toggleSection('dataSource')}>
        <div className="crb-config-header-left">
          <Database size={18} />
          <span className="crb-config-header-title">Data Source</span>
          {selectedDataSource && dataSources?.[selectedDataSource] && (
            <span className="crb-config-header-badge">
              {dataSources[selectedDataSource].label}
            </span>
          )}
        </div>
        <ChevronDown size={16} className={`crb-config-chevron ${expanded ? 'open' : ''}`} />
      </div>

      {expanded && (
        <div className="crb-config-body">
          {isLoading ? (
            <div className="crb-loading" style={{ padding: '20px' }}>
              <div className="crb-spinner" />
              <p>Loading sources...</p>
            </div>
          ) : (
            <div className="crb-source-grid">
              {dataSources && Object.entries(dataSources).map(([key, source]) => (
                <div
                  key={key}
                  className={`crb-source-card ${selectedDataSource === key ? 'selected' : ''}`}
                  onClick={() => setSelectedDataSource(key)}
                >
                  <div className="crb-source-icon">
                    {DATA_SOURCE_ICONS[key] || DEFAULT_DATA_SOURCE_ICON}
                  </div>
                  <div className="crb-source-info">
                    <h4>{source.label}</h4>
                    <p>{source.description}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(DataSourceSection);
